export const defaultBaseHeight = 0 
export const defaultHeight = 0            // in meters

export const categoriesHeights = {
    'muro': {
        'base_height': 0,
        'height': 2.8
    },
    'losa': {
        'base_height': 2.8,
        'height': 3
    },
    'viga': {
        'base_height': 2.8,
        'height': 3.1
    }
}

const defaultHeightConfig = ['number', ['get', 'height'], defaultHeight] 
const defaultBaseHeightConfig = ['number', ['get', 'base_height'], defaultBaseHeight]
const fullHeightConfig = ['number', ['get', 'level_height'], defaultHeight]
const fullBaseHeightConfig = ['number', ['get', 'base_level_height'], defaultBaseHeight]

export function handleBuildingHeight(map, fullBuilding) {
    let baseHeight = fullBuilding ? fullBaseHeightConfig : defaultBaseHeightConfig
    let height = fullBuilding ? fullHeightConfig : defaultHeightConfig
    map.setPaintProperty('cardPolygonLayer', 'fill-extrusion-base', baseHeight)
    map.setPaintProperty('cardPolygonLayer', 'fill-extrusion-height', height)
}